<template>
  <header id="slideInHeader" class="flex items-center gap-6 px-6 py-4">
    <Button icon-only :variant="ButtonVariant.Tertiary" @click="() => emits(isSubpage ? 'back' : 'close')">
      <Icon :src="isSubpage ? 'ArrowLeft' : 'ArrowLineRight'" />
    </Button>
    <p class="text-body-default-m grow truncate">
      <span v-if="prefix" class="text-body-default text-fgr-disabled mr-1.5">{{ prefix }}</span>
      {{ title }}
    </p>
    <div v-if="actions.length || $slots.actions" class="flex shrink-0 items-center gap-1.5">
      <slot name="actions" />
      <DropdownActions v-if="actions.length" :actions="actions" trigger-icon-prefix="dots_three_vertical" />
    </div>
  </header>
</template>

<script lang="ts" setup>
  const {
    actions: actions = [],
    isSubpage = false,
    title = "",
    prefix = undefined,
  } = defineProps<{
    actions?: DropdownOption[];
    isSubpage?: boolean;
    title?: string;
    prefix?: string | undefined;
  }>();
  const emits = defineEmits<{
    (e: "back" | "close"): void;
  }>();
</script>
